import { render } from "./ParserVacancyFull.vue?vue&type=template&id=e845750e&scoped=true"
import script from "./ParserVacancyFull.vue?vue&type=script&lang=js"
export * from "./ParserVacancyFull.vue?vue&type=script&lang=js"

import "./ParserVacancyFull.vue?vue&type=style&index=0&id=e845750e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e845750e"]])

export default __exports__